import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as html2pdf from 'html2pdf.js';
import { ApiService } from '../../core/api.service';
import { endPoints } from '../../core/Apis/apiEndpoints';
import { PdfDownloadService } from '../pdf-download.service';

@Component({
  selector: 'app-summary-report',
  templateUrl: './summary-report.component.html',
  styleUrls: ['./summary-report.component.css']
})
export class SummaryReportComponent implements OnInit {

  isLoader: boolean = false;
  disableButton: boolean = false;
  productHistoryData: any = null;

  constructor(private route: ActivatedRoute, private apiservice: ApiService, private pdfService: PdfDownloadService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      // const id = 'eb893bf7-decc-4d82-867b-5e86caffb37a';
      // const id = '173ec4de-aadd-42e1-b638-0047592bc0c5';
      // const id = '4ef50a4e-f457-4bee-ac86-b472c1525b0d';
      const token = this.route.snapshot.queryParamMap.get('token');
      console.log('Fetched ID from route:', id);
      console.log('Fetched Token from query params:', token);
      if (id && token) {
        this.getData(id, token);
      } else {
        console.error("ID or Token missing in URL");
      }
    });
  }
  
  getData(id: string, token: string) {
    this.isLoader = true;
    const headers = { Authorization: `Bearer ${token}` };
    this.pdfService
      .get(endPoints.factoryProductHistory + '/details/' + id, undefined, { headers })
      .subscribe({
        next: (res) => {
          this.productHistoryData = res?.data?.[0] || null;
          this.isLoader = false;
          this.debugBatchData();
        },
        error: (error) => {
          console.error('Error fetching matrix data:', error);
          this.isLoader = false;
        },
      });
  }
  debugBatchData() {
  console.log('=== DEBUG BATCH DATA START ===');
  
  if (!this.productHistoryData) {
    console.log('❌ productHistoryData is null or undefined');
    return;
  }
  
  console.log('✅ productHistoryData exists:', this.productHistoryData);
  
  if (!this.productHistoryData.rm_lists) {
    console.log('❌ rm_lists is null or undefined');
    return;
  }
  
  console.log('✅ rm_lists exists, length:', this.productHistoryData.rm_lists.length);
  
  if (this.productHistoryData.rm_lists.length === 0) {
    console.log('❌ rm_lists is empty array');
    return;
  }
  
  const firstBatch = this.productHistoryData.rm_lists[0].batch[0];
  console.log('✅ First batch item:', firstBatch);
  
  // Check ALL available fields in the batch object
  console.log('=== ALL BATCH FIELDS ===');
  Object.keys(firstBatch).forEach(key => {
    console.log(`- ${key}:`, firstBatch[key]);
  });
  
  console.log('Batch Image Time:', firstBatch?.batch_img_time);
  console.log('QTY Image Time:', firstBatch?.qty_img_time);
  
  // Check production_details data structure
  if (this.productHistoryData.production_details?.inventory) {
    console.log('=== PRODUCTION DETAILS INVENTORY ===');
    console.log('Inventory length:', this.productHistoryData.production_details.inventory.length);
    
    this.productHistoryData.production_details.inventory.forEach((item: any, index: number) => {
      console.log(`--- Inventory Item ${index} ---`);
      console.log('Item:', item.item_name);
      if (item.batch && item.batch.length > 0) {
        const productionBatch = item.batch[0];
        console.log('Production Batch:', productionBatch);
        console.log('Production Batch Image Time:', productionBatch.batch_img_time);
        console.log('Production QTY Image Time:', productionBatch.qty_img_time);
        
        // Check all fields in production batch
        console.log('=== ALL PRODUCTION BATCH FIELDS ===');
        Object.keys(productionBatch).forEach(key => {
          console.log(`- ${key}:`, productionBatch[key]);
        });
      } else {
        console.log('No batch data in production inventory');
      }
    });
  } else {
    console.log('❌ No production_details.inventory found');
  }
  
  console.log('=== DEBUG BATCH DATA END ===');
}

  
  exportToPdf() {
  this.disableButton = true;

  setTimeout(() => {
    const element = document.getElementById('report-template');
    
    if (!element) {
      console.error('report-template element NOT FOUND');
      this.disableButton = false;
      return;
    }

    console.log('Element found, dimensions:', element.offsetWidth, 'x', element.offsetHeight);

    const opt = {
      margin: [0.3, 0.02, 0.3, 0.02],
      filename: `Product-History-Report-${this.productHistoryData?.order_number || 'N/A'}.pdf`,
      image: {
        type: 'jpeg',
        quality: 0.7
      },
      html2canvas: {
        scale: 1,
        useCORS: true,
        scrollY: -window.scrollY,
        allowTaint: true,
        logging: false,
        imageTimeout: 0,
        removeContainer: true,
        ignoreElements: (el: HTMLElement) => el.classList.contains('no-export'),
        onclone: (clonedDoc: Document) => {
          const images = clonedDoc.querySelectorAll('img');
          images.forEach((img: Element) => {
            const htmlImg = img as HTMLImageElement;
            htmlImg.style.maxWidth = '150px';
            htmlImg.style.maxHeight = '120px';
            htmlImg.style.objectFit = 'contain';
          });
          const imageContainers = clonedDoc.querySelectorAll('.image-with-timestamp');
          imageContainers.forEach((container: Element) => {
            const htmlContainer = container as HTMLElement;
            htmlContainer.style.pageBreakInside = 'avoid';
            htmlContainer.style.breakInside = 'avoid-page';
          });
        }
      },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait'
      },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
        before: ['.page-break-before'],
        after: ['.page-break-after'],
        avoid: ['.avoid-break-inside', 'img', '.test-image', '.image-with-timestamp']
      }
    };

    html2pdf()
      .set(opt)
      .from(element)
      .toCanvas()
      .toPdf()
      .get('pdf')
      .then((pdf: any) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(100);
          pdf.text(
            `Page ${i} of ${totalPages}`,
            pdf.internal.pageSize.getWidth() / 2,
            pdf.internal.pageSize.getHeight() - 0.3,
            { align: 'center' }
          );
        }
        return pdf;
      })
      .output('blob')
      .then((blob: Blob) => {
        this.downloadPDF(blob, opt.filename as string);
        this.disableButton = false;
      })
      .catch((error: any) => {
        console.error('PDF generation error:', error);
        this.disableButton = false;
      });

  }, 1500);
}

  // Convert Blob to DataURL and trigger download
  private downloadPDF(blob: Blob, filename: string) {
    const reader = new FileReader();
    reader.onloadend = function () {
      const base64data = reader.result as string;

      const a = document.createElement('a');
      a.href = base64data; // data:application/pdf;base64,...
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    reader.readAsDataURL(blob);
  }

  shouldShowRed(qcTestResult: any): boolean {
    if (!qcTestResult.test_result || qcTestResult.test_result === '-' || qcTestResult.test_result === 'As Per Standard') {
      return false;
    }

    

    // Check if test_result is not between min and max
    const testResult = parseFloat(qcTestResult.test_result);
    const min = parseFloat(qcTestResult.minimum);
    const max = parseFloat(qcTestResult.maximum);

    if (isNaN(testResult)) {
      return true; // Show red for non-numeric values that aren't 'As Per Standard'
    }
    // Show red if value is outside min-max range
    return testResult < min || testResult > max;
  }

  formatTimestamp(timestamp: string): string {
  if (!timestamp) return '';
  
  try {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return timestamp;
  }
}

  // Helper methods for data formatting
  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  calculateTotalQuantity(items: any[]): number {
    return items?.reduce((sum, item) => sum + (item.quantity || 0), 0) || 0;
  }

  getStatusBadgeClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'completed': return 'status-completed';
      case 'in progress': return 'status-in-progress';
      case 'pending': return 'status-pending';
      default: return 'status-default';
    }
  }
}